var CollapsableModel = /** @class */ (function () {
    function CollapsableModel() {
    }
    return CollapsableModel;
}());
export { CollapsableModel };
